<template>
  <!-- Modal -->
  <p-modal
    name="email-draft-order-modal"
    class="email-draft-order-modal"
    :width="876"
    :height="'90%'"
  >
    <div class="email-collection-modal">
      <div class="modal-header">
        <h4 class="text-center text-uppercase mb-0">
          Email Draft Order
        </h4>
      </div>
      <div class="modal-body">
        <form>
          <div class="checkbox-group">
            <div class="checkbox-group-item">
              <checkbox name="draft-order" class-name="draft-order">
                Draft Order
              </checkbox>
            </div>
            <div class="checkbox-group-item">
              <checkbox name="pdf-catalog" class-name="mr-2 pdf-catalog">
                PDF Catalog
              </checkbox>

              <toggle-switch
                id="pdf-c-notes"
                label="Notes"
                class-name="pdf-notes"
              />
              <toggle-switch
                id="pdf-c-description"
                label="Description"
                class-name="pdf-description"
              />
              <toggle-switch
                id="pdf-c-cost"
                label="Cost"
                class-name="pdf-cost"
              />
              <toggle-switch
                id="pdf-c-inventory"
                label="Inventory"
                class-name="pdf-inventory"
              />

              <div class="d-flex align-items-center ms-3">
                <select class="form-select" aria-label="Criteria">
                  <option>2 Image View</option>
                  <option>4 Image View</option>
                  <option selected>
                    8 Image View
                  </option>
                  <option>12 Image View</option>
                </select>
                <a class="ms-3" href="#" @click="openPreviewProductsModal"
                  >Preview</a
                >
              </div>
            </div>
            <div class="checkbox-group-item">
              <checkbox name="embeded-xls">
                Embeded XLS
              </checkbox>
            </div>
            <div class="logo-header">
              <div>
                <div
                  class="d-flex justify-content-center align-items-center add-edit-container"
                >
                  <span>Logo Header:</span>
                  <div>
                    <a
                      class="text-uppercase me-2"
                      @click="openLogoSelectionModal"
                      >Edit</a
                    >
                    <a class="text-uppercase" @click="openLogoSelectionModal"
                      >Add</a
                    >
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <img src="/img/images/logo1.png" />
              </div>
            </div>
          </div>
          <div class="input-field-wrapper">
            <div class="mb-2 link-expiration-wrapper">
              <label for="collectionName" class="form-label"
                >Link Expiration</label
              >
              <div class="d-flex align-items-center">
                <datepicker
                  name="linkExpiration"
                  input-class="link-expiration"
                  format="MM/dd/yy"
                />

                <popper
                  :options="{
                    placement: 'right',
                    modifiers: { offset: { offset: '0px,10px' } },
                  }"
                >
                  <div class="popper">
                    <div class="popover-container">
                      <p class="text-start">
                        Collection & Digital Catalog links will expire and
                        become inactive on selected date
                      </p>
                    </div>
                  </div>
                  <div slot="reference" class="d-flex align-items-center ms-2">
                    <fa icon="info-circle" fixed-width />
                  </div>
                </popper>
              </div>
            </div>
            <div class="mb-2 buyer-email">
              <label class="form-label">Buyer Email:</label>
              <input
                type="text"
                class="form-control"
                placeholder="To send a COLLECTION, buyer must be a saved Pacific Silk Contact. if not a saved contact, send as a DIGITAL CATALOG."
              />
            </div>
            <div class="mb-1">
              <label class="form-label">CC:</label>
              <input
                type="text"
                class="form-control"
                placeholder="To send a COLLECTION, buyer must be a saved Pacific Silk Contact. if not a saved contact, send as a DIGITAL CATALOG."
              />
            </div>
            <div class="mb-4">
              <label for="collectionDescription" class="form-label"
                >Message:</label
              >
              <textarea
                id="collectionDescription"
                class="form-control"
                rows="5"
              />
            </div>
          </div>
          <div class="d-flex justify-content-end footer-wrapper">
            <button type="submit" class="bg-dark text-white border-0 me-2">
              Send
            </button>
            <button
              type="button"
              class="bg-secondary text-white border-0 ms-2"
              @click="closeModal"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </p-modal>
</template>

<script>
import ToggleSwitch from "~/components/core/Inputs/ToggleSwitch";
import PModal from "~/components/core/PModal";

export default {
  name: "EmailDraftOrderModal",
  components: { PModal, ToggleSwitch },
  methods: {
    closeModal() {
      this.$modal.hide("email-draft-order-modal");
      this.$emit("closeModal");
    },
    openLogoSelectionModal() {
      this.$emit("openLogoSelectionModal");
    },
    openPreviewProductsModal() {
      this.$emit("openPreviewProductsModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.email-draft-order-modal {
  ::v-deep {
    .vm--modal {
      max-height: inherit;
    }
  }
}
.email-collection-modal {
  max-width: 876px;
  padding: 32px 60px;

  .modal-header {
    border-bottom: none;
    justify-content: center;
    padding-bottom: 31px;
    h4 {
      font: normal normal normal 25px/28px Times New Roman;
    }
  }

  .modal-body {
    .checkbox-group {
      padding-bottom: 6px;
      &-item {
        margin-bottom: 15px;
        width: 100%;
        display: flex;

        a {
          text-decoration: underline;
          font: italic normal normal 13px/15px Arial;
          letter-spacing: 0px;
          color: #31b4d6;
        }
        > div {
          margin: 0px !important;
        }
        .pdf-notes {
          margin-left: 15px !important;
        }
        .pdf-description,
        .pdf-cost,
        .pdf-inventory {
          margin-left: 10px !important;
        }
        .form-select {
          margin-left: 15px;
        }
      }
    }
    .footer-wrapper {
      button {
        padding: 15px 70px;
        font: normal normal bold 16px/20px Arial;
        &:last-child {
          font: normal normal normal 16px/20px Arial;
        }
      }
    }

    .popover-container {
      max-width: 218px;
      padding: 10px;
      p {
        margin-bottom: 0px;
        font-style: italic;
      }
    }

    .logo-header {
      .add-edit-container {
        gap: 110px;
        margin-bottom: 20px;
        span {
          font: normal normal normal 14px/16px Arial;
        }
        a {
          color: #488abc;
          font: italic normal normal 14px/16px Arial;
        }
      }
      img {
        width: 243px;
        height: 47px;
      }

      a {
        font: italic normal normal 15px/15px Arial;
        text-decoration: underline;
        color: #31b4d6;
        cursor: pointer;
      }
    }
    .input-field-wrapper {
      label {
        font: normal normal normal 14px/16px Arial;
        margin-bottom: 10px;
      }
      .link-expiration-wrapper {
        label {
          font: normal normal normal 14px/16px Arial;
          margin-bottom: 3px;
        }
      }
      input {
        font: italic normal normal 13px/18px Arial;
      }
    }
  }
}
::v-deep {
  .link-expiration {
    height: 38px;
    font: normal normal normal 15px/20px Arial;
    letter-spacing: 0px;
    color: #000000;
    text-align: center;
    padding: 8px 0px;
    display: block;
    background-color: #ffffff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    appearance: none;
    border-radius: 0.125rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    width: 122px;
  }
  .checkbox-group {
    .form-check-label {
      font: normal normal normal 13px/15px Arial;
      letter-spacing: 0px;
      color: #000000;
      margin-left: 5px !important;
    }
    .form-check.form-switch .form-check-label {
      margin-top: 6px;
    }
  }
}
</style>
